/* eslint-disable react/prop-types */

import React from 'react';

import {connect} from 'react-redux';

import Diagram from '@/components/diagram/Diagram';
import * as APPDATA from '@/constants/pcConstAppData';

import '../status/AutoProfileStatus.less';

function convertBoolean(bool) {
  if (bool === 'true' || bool === 'True' || bool === true) {
    return true;
  }
  return false;
}

@connect((store) => {
  const {currentPCState, advSetupSelected, recoveryOfLiquidStatus, profileRunning, currentIsMoreThan50ml} =
    store.setupStore;

  const moreThan50ml = profileRunning[APPDATA.KEY.Config][APPDATA.KEY.MoreThan50ml];

  const skipPrime = convertBoolean(
    advSetupSelected !== undefined ? advSetupSelected.ConfigAdvSetup.GeneralAdvSetup.SkipPriming : false,
  );

  return {
    isPaused: store.setupStore.isPCPaused,
    isRunning: store.setupStore.isPCRunning,
    currentState:
      // eslint-disable-next-line no-nested-ternary
      currentPCState === APPDATA.PC_RECOVERING_STATE
        ? `${APPDATA.PC_RECOVERING_STATE}-${recoveryOfLiquidStatus[APPDATA.KEY.CurrentRecoveryStatus]}`
        : currentPCState === APPDATA.PC_FILL_MEMBRANE
        ? APPDATA.PC_PREPARING_STATE
        : currentPCState,
    moreThan50ml:
      moreThan50ml === -1 ? String(currentIsMoreThan50ml) === APPDATA.ENUM.MORE_THAN_50_ML.ON : moreThan50ml,
    skipPrime,
  };
})
class StatusDiagram extends React.PureComponent {
  render() {
    const {isPaused, isRunning, currentState, moreThan50ml, skipPrime} = this.props;

    return (
      <Diagram
        scaleSize="medium"
        skipPrime={skipPrime}
        isPaused={isPaused}
        isRunning={isRunning}
        currentState={currentState}
        moreThan50ml={moreThan50ml}
      />
    );
  }
}
export default StatusDiagram;
